import { render, staticRenderFns } from "./CAApplyPassword_2.vue?vue&type=template&id=7f036130&scoped=true&"
import script from "./CAApplyPassword_2.vue?vue&type=script&lang=js&"
export * from "./CAApplyPassword_2.vue?vue&type=script&lang=js&"
import style0 from "./CAApplyPassword_2.vue?vue&type=style&index=0&id=7f036130&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f036130",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VForm,VIcon,VTextField})
